import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
	state: {
		profile: '',
		status: '',
	},
	mutations: {
		customerRequest: (state) => {
			state.status = 'loading';
		},
		customerSuccess: (state, profile) => {
			state.status = 'success';
			Vue.set(state, 'profile', profile);
		},
		customerError: (state) => {
			state.status = 'error';
		},
		authLogout: (state) => {
			state.profile = {};
		},
	},
	actions: {
		customerRequest ({commit, dispatch}) {
			return new Promise((resolve, reject) => {
				commit('customerRequest');

				axios.get(`/customers/me`)
				.then(resp => {
					let customer = resp.data.response.customer;
					commit('customerSuccess', customer);
					dispatch('updateYarnsArchive');
					resolve(resp);
				})
				.catch(err => {
					// dispatch('authError', {err: err});
					// commit('customerError');
					reject(err);
				});
			});
		}
	}, getters: {
		getProfile: state => state.profile,
		isProfileLoaded: state => !!state.profile.name,
	}
}
